import METADATA from "./TranslateForAdminEntity.metadata.js";
import { BaseEntity } from "clavis-nxt-components-custdevtm";

class TranslateForAdminEntity extends BaseEntity {
  constructor(id, labelCode, moduleCode, translationValue) {
    super();
    this.id = id;
    this.labelCode = labelCode;
    this.moduleCode = moduleCode;
    this.translationValue = translationValue;
  }
}

METADATA.connect(TranslateForAdminEntity);

export { TranslateForAdminEntity };
